import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { HTTPCONSTANTS } from './http-constants';
import { environment } from 'src/environments/environment';
import { environment as _environemnt } from 'src/app/environment';

/** All API base URLs come from environment. Canonical base is api.platex.co.uk (mapped to API via CloudFront → EC2). */
const LEGACY_API_ORIGIN = 'https://api.platex.co.uk/api';
const LEGACY_API_ORIGIN_HTTP = 'http://api.platex.co.uk/api';
const CLOUDFRONT_API_BASE = 'https://d3j6eu5y3tsx1j.cloudfront.net/api';

@Injectable()
export class UrlInterceptor implements HttpInterceptor {
  private useLocalAPI: boolean = true;
  private useLocalPlato: boolean = false;

  constructor() { }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let url = request.url;

    // Ensure all API calls use the canonical base (api.platex.co.uk); rewrite legacy or CloudFront URLs to it
    const apiBase = environment.apiProtocol + environment.apiBaseAddress;
    if (url.indexOf('api.platex.co.uk') !== -1) {
      url = url.replace(LEGACY_API_ORIGIN, apiBase).replace(LEGACY_API_ORIGIN_HTTP, apiBase);
      return next.handle(request.clone({ url }));
    }
    if (url.indexOf('d3j6eu5y3tsx1j.cloudfront.net') !== -1) {
      url = url.replace(CLOUDFRONT_API_BASE, apiBase);
      return next.handle(request.clone({ url }));
    }

    if (request.url.indexOf(HTTPCONSTANTS.dataApiBaseAddress) > -1) {
      // DATA API (MarketWatch, DVLAAuction) → CloudFront/EC2 – Top Auction Results, Live Feed, DVLA search
      var protocol = environment.dataApiProtocol;
      var baseAddress = environment.dataApiBaseAddress;
      request = request.clone({
        url: request.url
          .replace(HTTPCONSTANTS.dataApiProtocol, protocol)
          .replace(HTTPCONSTANTS.dataApiBaseAddress, baseAddress),
      });
    } else if (request.url.indexOf(HTTPCONSTANTS.apiBaseAddress) > -1) {
      // MAIN API (auth, user, listings, platedetails, blog, etc.) → CloudFront/EC2
      var protocol = environment.apiProtocol;
      var baseAddress = environment.apiBaseAddress;
      if (!environment.production && this.useLocalAPI) {
        protocol = environment.local_apiProtocol;
        baseAddress = environment.local_apiBaseAddress;
      }
      request = request.clone({
        url: request.url
          .replace(HTTPCONSTANTS.protocol, protocol)
          .replace(HTTPCONSTANTS.apiBaseAddress, baseAddress),
      });
    } else if (request.url.indexOf(HTTPCONSTANTS.platoBaseAddress) > -1) {
      // PLATEX PLATO REQUEST
      var protocol = environment.platoProtocol;
      var baseAddress = environment.platoBaseAddress;
      if (!environment.production && this.useLocalPlato) {
        protocol = environment.local_platoProtocol;
        baseAddress = environment.local_platoBaseAddress;
      }
      request = request.clone({
        url: request.url
          .replace(HTTPCONSTANTS.platoProtocol, protocol)
          .replace(HTTPCONSTANTS.platoBaseAddress, baseAddress),
      });
    } else if (request.url.indexOf(HTTPCONSTANTS.editorialApiBaseAddress) > -1) {
      // EDITORIAL INTELLIGENCE (Dev2 Plato FastAPI/Lambda HttpApi). Dev2-only PoC;
      // the same isolated host is used in dev and prod builds. Do NOT append the
      // plato-search '&environment=dev' suffix here.
      request = request.clone({
        url: request.url
          .replace(HTTPCONSTANTS.editorialApiProtocol, environment.editorialApiProtocol)
          .replace(HTTPCONSTANTS.editorialApiBaseAddress, environment.editorialApiBaseAddress),
      });
    } else {
      // PLATEX PLATO SEARCH REQUEST
      var protocol = environment.platoSearchProtocol;
      var baseAddress = environment.platoSearchBaseAddress;
      var env = _environemnt.dev() ? '&environment=dev' : '';
      request = request.clone({
        url:
          request.url
            .replace(HTTPCONSTANTS.plato_search_protocol, protocol)
            .replace(HTTPCONSTANTS.plato_search_base, baseAddress) + env,
      });
    }
    return next.handle(request);
  }
}
